module.exports = __webpack_public_path__ + "static/media/logo_envases.c52438f2.png";